import { SparklesIcon } from '@heroicons/react/24/solid';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton, Text } from '@/shared/ui';

/**
 * 初期チャットビュー（AI分析中）
 */

export const InitialChatView: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <SparklesIcon className="h-[16px] w-[16px] text-primary" />
        <Text variant="description">{t('ai.analysis.analyzing')}</Text>
      </div>
      <Skeleton color="primary" className="h-4 w-full" />
      <Skeleton color="primary" className="h-4 w-full" />
      <Skeleton color="primary" className="h-4 w-full" />
    </div>
  );
};
